import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const text = css`
  flex: 1;
  align-items: center;
  padding-right: ${styles.size[8]};
`
